import { withConfig } from 'hoc/config.hoc.js';
import FooterView from 'components_footer_brand/FooterView';

const Footer = ({ datatestid, ...props }) => {
  return <FooterView {...props} datatestid={datatestid} />;
};
const connectedFooter = withConfig(Footer);

export { connectedFooter as Footer };
